export enum SyncMenuSectionImagesMode {
  DoNotSync = 'do-not-sync',
  SyncAsHeaderImage = 'sync-as-header-image',
  SyncAsPageNavImage = 'sync-as-page-nav-image',
}
